module.exports = ".progress-bar {\r\n    border-radius: 5px;\r\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/cambio-pass/cambio-pass.component.css
// module id = ./src/app/cambio-pass/cambio-pass.component.css
// module chunks = main